import React from 'react';
import api from './api';
import './Doctors.css';
import Diagnosis from './Diagnosis';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AuthContext from '../hooks/useAuth';
import DatePicker from 'react-datepicker'; // if you're using this

class Consultation extends React.Component {
    static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      patients: [],
      auth: {},
      newPatient: { name: '', age: '', gender: 'male', address: '', number: '', patientCard: '', registrationDate: new Date(), therapist: 'selectT' },
      selectedPatient: null,
      therapists: [],
      sequences: [],
      patientSequences: null,
      isEditMode: true,
      isModalOpen: false,
      hasModalChanged: false,
      modalData: null,
      activeTab: 0
    };
  }

  componentDidMount() {
    console.log("props patient =", this.props.patientCard);

    if (!this.props.patientCard) {
      return <div>Loading patient details...</div>;  // or null or spinner
    }
    this.fetchPatient();
    this.fetchTherapists();
  }

  fetchPatient = () => {
    api.get(process.env.REACT_APP_URL + '/patients/consultation/' + this.props.patientCard)
      .then(function (response) {
        this.setState({ selectedPatient: response.data });
      }.bind(this))
      .catch(function (error) {
        console.error('Fetch error', error);
      });
  };

  fetchTherapists = () => {
    api.get(process.env.REACT_APP_URL + '/users/therapist')
      .then(function (response) {
        this.setState({ therapists: response.data });
      }.bind(this))
      .catch(function (error) {
        console.error('Therapist fetch error', error);
      });
  };

  handleTabSelect = function (index) {
    this.setState({ activeTab: index });
  }.bind(this);

  handleEditPatient = function (id) {
    var sel = this.state.patients.find(function (p) { return p._id === id; });
    this.setState({ selectedPatient: sel, isModalOpen: true, isEditMode: true });
  }.bind(this);

  handlePatientDetails = function (patient) {
    this.setState({
      selectedPatient: null,
      isEditMode: false,
      isModalOpen: true,
      hasModalChanged: true,
      modalData: patient
    });
  }.bind(this);

  handleAddNewPatient = function () {
    this.setState({
      selectedPatient: null,
      isEditMode: false,
      isModalOpen: true,
      hasModalChanged: false,
      modalData: null
    });
  }.bind(this);

  handleClose = function () {
    this.setState({
      isModalOpen: false,
      selectedPatient: null,
      isEditMode: false,
      hasModalChanged: false,
      modalData: null
    });
    // optionally: this.fetchPatient();
  }.bind(this);

  render() {
    const auth = this.context.auth;
    const { patientCard } = this.props;
    
    if (!patientCard) {
      return <div>Loading patient details...</div>;  // or null or spinner
    }
    var state = this.state;

    return (
      <div className="patient-main">
        <Tabs selectedIndex={state.activeTab} onSelect={this.handleTabSelect}>
          <TabList className="tabs-container">
            <Tab>Diagnosis</Tab>
            <Tab>History Evaluation</Tab>
          </TabList>

          <TabPanel>
            {console.log("patientCard being passed to Diagnosis:", this.props.patientCard)}
            
            <Diagnosis patientCard={this.props.patientCard} /> 
          </TabPanel>

          <TabPanel>
            { state.isModalOpen && state.hasModalChanged && state.modalData ? (
                <div className="patient-details-wrapper">...</div>
              ) : (
                <form onSubmit={ state.isEditMode ? function(e){ e.preventDefault(); /* update logic */ } : function(e){ e.preventDefault(); /* add logic */ } }>
                  <div className="ele">
                    <label>Medical History:</label>
                    <input
                      type="text"
                      value={ state.isEditMode && state.selectedPatient ? state.selectedPatient.mhistory : '' }
                      onChange={function(e){
                        var value = e.target.value;
                        if (state.isEditMode) {
                          var sp = Object.assign({}, state.selectedPatient);
                          sp.mhistory = value;
                          this.setState({ selectedPatient: sp });
                        } else {
                          var np = Object.assign({}, state.newPatient);
                          np.mhistory = value;
                          this.setState({ newPatient: np });
                        }
                      }.bind(this)}
                    />
                  </div>
                  <button type="submit">{state.isEditMode ? 'Update data' : 'Add data'}</button>
                </form>
              )
            }
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

export default Consultation;
